// extracted by mini-css-extract-plugin
export default {"heading":"_s-z","corrected":"at-z","redirectVerbiageContainer":"bt-z","redirectVerbiageText":"ct-z"};